import React, { useState } from 'react';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import FnbApi from '~/src/services/api/FnbApi';

interface Props {
  dataItemId: string;
}
export default function ResetFnbOrder({ dataItemId }: Props): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <SecondaryButton
      title="R"
      onClick={async (): Promise<void> => {
        setLoading(true);
        const res = await FnbApi.resetFnb(dataItemId);
        setLoading(false);
      }}
      isSubmitting={loading}
      size="sm"
    />
  );
}
